/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSplitStatusDto
 */
export interface PaymentSplitStatusDto {
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    grossAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    terminalTipAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    grossAmountAfterAddingTerminalTip: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    paymentFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    commissionAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    refundedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    pendingRefundAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    refundableAmount: number;
}

/**
 * Check if a given object implements the PaymentSplitStatusDto interface.
 */
export function instanceOfPaymentSplitStatusDto(value: object): value is PaymentSplitStatusDto {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    return true;
}

export function PaymentSplitStatusDtoFromJSON(json: any): PaymentSplitStatusDto {
    return PaymentSplitStatusDtoFromJSONTyped(json, false);
}

export function PaymentSplitStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSplitStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'grossAmount': json['grossAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'commissionAmount': json['commissionAmount'],
        'netAmount': json['netAmount'],
        'refundedAmount': json['refundedAmount'],
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundableAmount': json['refundableAmount'],
    };
}

export function PaymentSplitStatusDtoToJSON(json: any): PaymentSplitStatusDto {
    return PaymentSplitStatusDtoToJSONTyped(json, false);
}

export function PaymentSplitStatusDtoToJSONTyped(value?: PaymentSplitStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'grossAmount': value['grossAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'commissionAmount': value['commissionAmount'],
        'netAmount': value['netAmount'],
        'refundedAmount': value['refundedAmount'],
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundableAmount': value['refundableAmount'],
    };
}

